module.exports = __webpack_public_path__ + "static/media/Zoom_Out.617c544e.svg";